// Copyright 2017 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";

@customElement("expander")
export class Expander {
    @bindable
    public collapsed = true;

    @bindable
    public title: string;

    @bindable
    public icon: string;

    @bindable
    public iconPlaceLeft = false;
}
